import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'prop-types';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconCloseContextualPanel = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsxs(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    "data-mntl-flip-svg": "true"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("path", {
      d: "M8.696 16.682a.772.772 0 010-1.096l2.825-2.81h-7.47A.777.777 0 013.274 12c0-.428.348-.775.779-.775h7.47l-2.826-2.81a.772.772 0 010-1.097.782.782 0 011.102 0l4.155 4.134a.772.772 0 010 1.096l-4.155 4.134a.782.782 0 01-1.102 0z",
      fill: color
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.182 24A2.182 2.182 0 010 21.818V2.182C0 .977.977 0 2.182 0h19.636C23.023 0 24 .977 24 2.182v19.636A2.182 2.182 0 0121.818 24H2.182zM17.454 1.09h4.364c.603 0 1.091.49 1.091 1.092v19.636a1.09 1.09 0 01-1.09 1.091h-4.364V1.091zm-1.09 0v21.82H2.182a1.09 1.09 0 01-1.091-1.092V2.182c0-.603.488-1.091 1.09-1.091h14.183z",
      fill: color
    })]
  }));
});
IconCloseContextualPanel.displayName = "IconCloseContextualPanel";

export { IconCloseContextualPanel };
